import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import {
	OTA_PRICE_STATE_SNAPSHOT_FRAGMENT,
	PARITY_SNAPSHOT_FRAGMENT,
} from '@app/model/parity/service/ParityGraphQLFragments';

export const FIND_PARITY_FOR_PERIOD: GraphQL = {
	name: 'findParityForPeriod',
	gql: gql`
      ${PARITY_SNAPSHOT_FRAGMENT}
      query findParityForPeriod($companyHotelId: Long!, $startStatDate: LocalDate!, $endStatDate: LocalDate!, $filterInput: ParityFilterInput!) {
          findParityForPeriod(companyHotelId: $companyHotelId, startStatDate: $startStatDate, endStatDate: $endStatDate, filterInput: $filterInput) {
              ...ParitySnapshotFragment
          }
      }
	`,
};

export const FIND_PARITY_FOR_MONTH: GraphQL = {
	name: 'findParityForMonth',
	gql: gql`
      ${PARITY_SNAPSHOT_FRAGMENT}
      query findParityForMonth($companyHotelId: Long!, $year: Int!, $month: Month!, $filterInput: ParityFilterInput!) {
          findParityForMonth(companyHotelId: $companyHotelId, year: $year, month: $month, filterInput: $filterInput) {
              ...ParitySnapshotFragment
          }
      }
	`,
};

export const FIND_OTA_PRICES_FOR_PERIOD: GraphQL = {
	name: 'findOtaPricesForPeriod',
	gql: gql`
      ${OTA_PRICE_STATE_SNAPSHOT_FRAGMENT}
      query findOtaPricesForPeriod($companyHotelId: Long!, $startStatDate: LocalDate!, $endStatDate: LocalDate!, $filterInput: ParityFilterInput!) {
          findOtaPricesForPeriod(companyHotelId: $companyHotelId, startStatDate: $startStatDate, endStatDate: $endStatDate, filterInput: $filterInput) {
              ...OtaPriceStateSnapshotFragment
          }
      }
	`,
};

export const FIND_OTA_PRICES_FOR_MONTH: GraphQL = {
	name: 'findOtaPricesForMonth',
	gql: gql`
      ${OTA_PRICE_STATE_SNAPSHOT_FRAGMENT}
      query findOtaPricesForMonth($companyHotelId: Long!, $year: Int!, $month: Month!, $filterInput: ParityFilterInput!) {
          findOtaPricesForMonth(companyHotelId: $companyHotelId, year: $year, month: $month, filterInput: $filterInput) {
              ...OtaPriceStateSnapshotFragment
          }
      }
	`,
};